export enum STATUS_RESPONSE {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
}

export type UseBooleanProps = {
  value: boolean
  setValue: (value: boolean) => void
}

export interface GeneralLabelValue {
  value: string | number
  label: any
}

export type FormDate = string | number | Date
export const emptyCheckPermissionPageDetail = {
  project: false,
  notificationProject: false,
  viewShare: false,
  notificationViewShare: false,
  component: false,
  notificationComponent: false,
  noUpdateFilePCB: false,
  notificationNoUpdateFilePCB: false,
  build: false,
  notificationBuild: false,
}
export enum VERSION_APPROVED_STATUS {
  PENDING,
  APPROVED,
  UNAPPROVED,
}

export type EncryptionKeyInput = {
  type: number
  encrypted_key: string
  model?: string
  relation_id: string
  user_id?: string
  additional_id?: string
  is_expired?: boolean
}

export enum KeyEncryptionType {
  ProjectShareKey,
  ConversationShareKey,
  ModuleKey,
  EncryptedVaultKey,
  BackupEncryptedVaultKey,
  ConversationShareKeys,
  ConvoContributorKey,
  ConversationNoteKey,
  EncryptedKMSBackupKey,
  EncryptedPrivateKey,
  PublicKey,
  ProjectBuildShareKey,
  ComponentShareKey,
  EncryptedBackupKeyCode,
  PublicKeyConversation,
  PrivateKeyConversation,
}

export enum GetKeysType {
  VaultKey = "VaultKey",
  ProjectKey = "ProjectKey",
  BuildKey = "BuildKey",
  ShareKey = "ShareKey",
  PublicKey = "PublicKey",
  PrivateKey = "PrivateKey",
  ConversationKey = "ConversationKey",
}
